<style scoped lang="less">
.table-list {
  padding: 20px 0;
  height: 34px;
}
</style>
<template>
  <div>
    <div class="page-content">
      <div class="title text-right">
        <el-button
          type="primary"
          size="mini"
          plain
          :loading="signBtn.isBtnLoading"
          :disabled="signBtn.isDisabled"
          >{{ signBtn.btnText }}</el-button
        >
      </div>
      <div class="content">
        <div class="table">
          <el-table
            :data="tableData"
            stripe
            size="mini"
            border
            v-loading="pageLoading"
          >
            <!-- <el-table-column label="设备名称" align="center"> </el-table-column> -->
            <el-table-column
              v-for="(item, key) in thTableList"
              :key="key"
              :prop="item.param"
              align="center"
              :label="item.title"
            ></el-table-column>
            <!-- <el-table-column label="状态" align="center" width="80">
              <template slot-scope="scope">
                <div class="font-color-success">{{ scope.row.statusStr }}</div>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </div>
      <div class="table-list text-center">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="pageData.totalCount"
          :page-size="pageData.pageSize"
          :current-page.sync="pageData.currentPage"
          @current-change="pageChange"
          v-if="!pageLoading && pageData.totalCount > 20"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "alarmTable",
  props: {
    tableData: Array,
    pageData: Object
    // pageChange: Function
  },
  data() {
    return {
      pageLoading: false,
      pageDataNew: {},
      pageData: {
        currentPage: 1,
        totalCount: 100,
        pageSize: 20
      },
      //   tableData: [],
      signBtn: {
        btnText: "全部标记为已读",
        isLoading: false,
        isDisabled: false
      },
      thTableList: [
        {
          title: "自动站名称",
          param: "station_name",
          width: ""
        },

        {
          title: "设备编号",
          param: "device_sn",
          width: ""
        },
        {
          title: "设备名",
          param: "device_name",
          width: ""
        },
        {
          title: "报警类别",
          param: "alarm_type",
          className: "",
          width: ""
        },
        {
          title: "报警项目",
          param: "alarm_field",
          width: ""
        },
        {
          title: "测量数据",
          param: "alarm_data",
          width: ""
        },
        {
          title: "报警时间",
          param: "alarm_time",
          width: ""
        }
      ]
    };
  },
  methods: {
    pageChange() {
      setTimeout(() => {
        console.log(
          "分页",
          this.pageData.currentPage,
          this.pageData.totalCount,
          this.pageData.pageSize
        );
        // this.search();
      });
    }
  },
  created() {
    // this.search();
  },
  watch: {
    pageData: {
      handler(val, oldVal) {
        this.pageDataNew = val;
      },
      deep: true
    }
    // totalCount(val, oldVal) {
    //   //普通的watch监听
    //   this.pageData.totalCount = val;
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/alarmTable.vue